import { render, staticRenderFns } from "./PError.vue?vue&type=template&id=0396309a"
import script from "./PError.vue?vue&type=script&lang=js"
export * from "./PError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports